/// <reference types="@angular/localize" />
import { enableMapSet } from 'immer';
import { enableProdMode, isDevMode, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { CoreModule } from '@core/core.module';
import { DatePipe } from '@angular/common';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './app/store/app.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AppEffect } from './app/store/app.effect';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { routes } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedModule } from '@shared/shared.module';
import { NgChartsModule } from 'ng2-charts';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { AppComponent } from './app/app.component';

enableMapSet();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    importProvidersFrom(
      StoreModule.forRoot({ app: appReducer }),
      EffectsModule.forRoot([AppEffect]),
      BrowserModule,
      CoreModule,
      SharedModule,
      NgChartsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      }),
      MonacoEditorModule.forRoot()
    ),
    CoreModule,
    DatePipe,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        },
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
